<script setup lang="ts">
import ModalFromBot from "@/components/Modal/ModalFromBot.vue";
import RichText from "@/components/RichText.vue";
import Tabbar from "@/components/Tabbar.vue";
import { $BigNumber,flatArr, iframePost, isInIframe, symbolByCurrency, updateCountdown } from '@/utils';
import _service from "@/service";
import { computed, onMounted, onUnmounted } from "vue";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { Image as VanImage, closeToast, showLoadingToast, showToast } from 'vant';
import { toRaw } from "vue";
import router from "@/router";
import { useI18n } from "vue-i18n";
import { isStarNest } from "@/utils/starnest";
import { useSystemStore } from "@/stores/system";
import moment from "moment";
import LanguagesModal from "@/components/Modal/LanguagesModal.vue";
const isShowBuyModal = ref<boolean>(false);
const showLangModal = ref<boolean>(false);
const productCur = ref<number>();
const sessionCur = ref<number>(0);
const stepNumber = ref<number>(1);
const detailData = ref<any>();
const timeCount = ref<any>('');
const productMap = ref<any>();
const descriptionLangList = ref<any>([]);
const productData = ref<any | null>();
const route = useRoute()
const id = route.params.id
let timer: any = null;
let countTimer: any = null;

type StorageLang = {
  lang:string,
  expireTime:number
}

const langList = ref([
  { label: "English", value: "en_US" },
  { label: "简体中文", value: "zh_CN" },
  { label: "繁體中文", value: "zh_TW" },
  { label: "日本語", value: "ja_JA" },
  { label: "한국어", value: "ko_KO" },
  { label: "ภาษาไทย", value: "th_TH" },
  { label: "Русский", value: "ru_RU" },
  { label: "Tiếng Việt", value: "vi_VN" },
]);


const systemStore = useSystemStore()

const globalCurrency = computed(()=>{
  return systemStore.globalCurrency
})

// 对美元汇率
const CoinRate = computed(()=>{
  return 1
})

const {t} = useI18n()

const handleStep = (type:string) => {
  if (type === '+') {
    // 超过限购
    if (productData.value.limitedPurchaseQuantity > 0 && stepNumber.value >= productData.value.limitedPurchaseQuantity) {
      return false
    }
    // 超过库存
    if (stepNumber.value >= productData.value.stock) {
      return false
    }
    // 超过100
    if (stepNumber.value >= 99) {
      return false
    }
    stepNumber.value++
  }else{
    if (stepNumber.value === 1) {
      return false
    }
    stepNumber.value--
  }
}

onMounted(()=>{
  getProductDetail()
  systemStore.setGlobalCurrency()
})

const currentLang = computed(()=>{
  if (detailData.value?.descriptionLangList.length) {
    const defaultLang = detailData.value?.descriptionLangList.filter((o:any)=>o.defaultLang === 'true')[0].lang
    setStorageLang(Number(detailData?.value.id),defaultLang)
    return defaultLang
  }else{
    return null
  }
  
})

const setStorageLang = (id:number,lang:string) => {
  const storageLangList = new Map<number,StorageLang>(JSON.parse(localStorage.getItem('DESCRIPTION_LANG_LIST') || 'null'))
  for (let item of storageLangList.keys()){
    console.log(item,'item==');
    if (storageLangList.get(item)?.expireTime < new Date().getTime()) {
      storageLangList.delete(item)
    }
  }
  storageLangList.set(id,{lang,expireTime:new Date().getTime() + 180 * 24 * 3600 * 1000})
  localStorage.setItem('DESCRIPTION_LANG_LIST',JSON.stringify(Array.from(storageLangList)))
}

const currentDescription = computed(()=>{
  if (detailData.value?.descriptionLangList.length) {
    return detailData.value?.descriptionLangList.filter((o:any)=>o.lang === currentLang.value)[0].description
  }else{
    return detailData.value?.description || null
  }
  
})

const getProductDetail = async() => {
  showLoadingToast({
    message: t("Loading"),
    duration: 0
  })
  try {
    const {data} = await _service.getProductDetail({id})
    const sessionsArr:any = []
    let valueIdArr:any = []
    let priceArr:any = []
    let marketPriceArr:any = []
    const storageLangList:any = new Map(JSON.parse(localStorage.getItem('DESCRIPTION_LANG_LIST') || 'null'))
    if (storageLangList) {
      let storageLang = storageLangList.has(data.id) ? storageLangList.get(data.id).lang : null
      console.log(storageLang,'storageLang--');
      if (storageLang) {
        data.descriptionLangList = data.descriptionLangList.map((item:any)=>{
          if (storageLang === item.lang) {
            item.defaultLang = "true"
          }else{
            item.defaultLang = "false"
          }
          return item
        })
      }
    }
    data.skus.map((item:any)=>{
      priceArr.push(Number($BigNumber(item.price).times(CoinRate.value).div(100)))
      marketPriceArr.push(Number($BigNumber(item.marketPrice).times(CoinRate.value).div(100)))
      let _valueId = item.properties.find((propertyItem:any)=>propertyItem.propertyId === 2).valueId
      !valueIdArr.includes(_valueId) && valueIdArr.push(_valueId)
      const {properties,...rest} = item
      
      sessionsArr.push({
        ...item.properties.filter((propItem:any)=>{return propItem.propertyId === 2})[0],
        children:[{
          ...item.properties.filter((propItem:any)=>{return propItem.propertyId === 1})[0],
          ...rest,
          initialPrice:item.price,
          price:$BigNumber(item.price).times(CoinRate.value).div(100).toFixed(2),
          priceSymbol:item.priceSymbol,
          marketPrice:$BigNumber(item.marketPrice).times(CoinRate.value).div(100).toFixed(2)
        }],
      })
    })
    const price_max = Math.max(...priceArr);
    const price_min = Math.min(...priceArr);
    const priceSymbol = sessionsArr[0].children[0].priceSymbol;
    const market_price_max = Math.max(...marketPriceArr);
		const market_price_min = Math.min(...marketPriceArr);
    const mergedItems = sessionsArr.reduce((accumulator:any, current:any) => {
        const existingItem = accumulator.find((item:any) => item.valueId === current.valueId);
        if (existingItem) {
          // 如果已存在相同valueId的对象，则合并这些属性
          existingItem.children.push(...current.children)
        } else {
          // 如果不存在，则直接添加到结果数组中
          accumulator.push(current);
        }
        return accumulator;
      }, []);
      // console.log(mergedItems,'mergedItems');
      mergedItems.sort((a:any,b:any)=>{
        return new Date(a.valueName).getTime() - new Date(b.valueName).getTime()
      }
    )
      mergedItems.map((item:any)=>{
        item.children.sort((a:any,b:any)=>b.stock - a.stock)
      })
    data.sessions = mergedItems
    const limitedPurchaseEndTime = Math.max.apply(Math, data.skus.map((o:any)=> {return o.limitedPurchaseEndTime}))
    const limitedPurchaseStartTime = Math.min.apply(Math, data.skus.map((o:any)=> {return o.limitedPurchaseStartTime}))
    console.log(limitedPurchaseStartTime,'limitedPurchaseStartTime');
    console.log(limitedPurchaseEndTime,'limitedPurchaseEndTime');
    console.log(price_min,'price_min');
    
    detailData.value = {...data,price_min,price_max,market_price_max,market_price_min,limitedPurchaseEndTime,limitedPurchaseStartTime,priceSymbol}
    if (detailData?.value.limitedPurchaseStartTime > new Date().getTime()) {
      countTimer = setInterval(() => {
        getTimeCount(detailData?.value.limitedPurchaseStartTime);
      }, 1000);
    }
    closeToast()
  } catch (error) {
    closeToast()
    showToast(`${error}`)
    console.log(`${error}`);
  }
}

const chooseProduct = (index:number)=> {
  productCur.value = index || 0
  productData.value = detailData?.value.sessions[sessionCur.value].children[index]
  console.log(productData.value,'productData--');
  stepNumber.value = 1
} 

const chooseSession = (index:number) => {
  sessionCur.value = index
  if (productCur.value === 0 || productCur.value) {
    chooseProduct(productCur.value)
  }
}

const setDescriptionLang  = (data:any) => {
   detailData.value.descriptionLangList = detailData.value.descriptionLangList.map((item:any)=>{
    if (data.lang === item.lang) {
      item.defaultLang = "true"
    }else{
      item.defaultLang = "false"
    }
    return item
  })
  showLangModal.value = false
}

const goConfirm = () => {
  if (!sessionStorage.getItem('APLINK_STARNEST_TOKEN')) {
    showToast(t('Please go to log in'))
    isInIframe() ?  iframePost('needlogin') : router.push('/login')
    return false
  }
  if (!productData.value) {
    showToast(t('Please select the ticket file'))
    return false
  }
  
  if (!productData.value.stock) {
    showToast(t('Insufficient commodity inventory'))
    return false
  }
  isShowBuyModal.value = false
  // console.log(productData,'productData');
  
  const _productData = {
    ...productData.value,
    picUrl:detailData.value?.picUrl,
    skuName:productData.value.valueName,
    name:`${detailData.value?.venue?.cityName || ''} | ${detailData.value?.name || ''}`,
    address:`${detailData.value?.venue?.cityName || ''} ${detailData.value?.venue?.name || ''}`,
    count:stepNumber.value,
    refundEnabled:detailData.value?.refundEnabled,
    transferEnabled:detailData.value?.transferEnabled,
    payPrice:$BigNumber(stepNumber.value).times(productData.value.price)
  }
  sessionStorage.setItem('ORDER_CONFIRM_DATA',JSON.stringify(_productData))
  router.push('/order-confirm')
}

const getTimeCount = (time:any) => {
  timeCount.value = updateCountdown(time, countTimer);
};

onUnmounted(() => {
  if (countTimer) {
    clearInterval(countTimer);
    countTimer = null;
  }
});

const buyFn = () =>{
  if (isInIframe() && !sessionStorage.getItem('APLINK_STARNEST_TOKEN')) {
    iframePost('needlogin')
    return false
  }
  isShowBuyModal.value = true
}

const getLangLabel = (lang:string) => {
  if (langList.value.filter(item=>item.value == lang).length) {
    return langList.value.filter(item=>item.value == lang)[0].label
  }
  
}
</script>

<template>
  <div class="product-detail-layout">
    
    <div class="media-375">
      <div class="product-bg">
        <img :src="detailData?.picUrl" alt="">
        <div class="bg-shadow"></div>
      </div>
        
      <div class="body">
        <div class="product-info flex-row-between-center">
          <div class="left">
            <VanImage
              radius="12"
              fit="cover"
              :src="detailData?.picUrl"
            />
          </div>
          <div class="right flex-col-start-start">
            <div class="title">
              {{ `${detailData?.venue?.cityName || ''} | ${detailData?.name || ''}`}}
            </div>
            <div class="store-time flex-row-start-center">
							{{detailData?.startTime === detailData?.endTime
	                  ? moment(detailData?.startTime).format('YY.MM.DD ddd HH:mm')
	                  : `${moment(detailData?.startTime).format('YY.MM.DD')} - ${moment(detailData?.endTime).format('MM.DD')}`
	              }}
						</div>
          </div>
        </div>
        <!-- <div class="fs-12 order-tip" v-if="detailData">
          <p class="item-wrap" v-if="!detailData?.refundEnabled">
            <i class="icon"></i>{{ t('No refunds') }}
          </p>
          <p class="item-wrap">
              <i class="icon" :class="detailData?.transferEnabled ? 'transfer' : 'notransfer'"></i>{{ detailData?.transferEnabled ? t('Transferable') : t('Not transferable') }}
          </p>
        </div> -->
        <div class="location-bar">
					<div class="main">
						<div class="flex-row-between-center">
              <div class="price number-font">
                <div class="flex-row-start-center">
                  <span class="coin">{{symbolByCurrency[detailData?.priceSymbol]}}</span>{{detailData?.price_min === detailData?.price_max ? detailData?.price_min:`${$BigNumber(detailData?.price_min || 0).toFixed(2)} - ${$BigNumber(detailData?.price_max || 0).toFixed(2)}`}}
                </div>
                <div class="market-price">
                  <span class="coin">{{symbolByCurrency[detailData?.priceSymbol]}}</span>{{detailData?.market_price_min === detailData?.market_price_max ? detailData?.market_price_min: `${$BigNumber(detailData?.market_price_min || 0).toFixed(2)} - ${$BigNumber(detailData?.market_price_max || 0).toFixed(2)}`}}
                </div>
              </div>
              <div class="buy-btn" @click="buyFn" :class="{'count-time':detailData?.limitedPurchaseStartTime > new Date().getTime(),'disabled':detailData?.limitedPurchaseStartTime > new Date().getTime() || detailData?.limitedPurchaseEndTime < new Date().getTime()}">
                  {{ detailData && detailData?.limitedPurchaseEndTime > new Date().getTime() ? t('Purchase') : t('Ended')  }}
                  <div class="time" v-if="detailData && detailData?.limitedPurchaseStartTime > new Date().getTime()">{{`${t('Countdown')}：${timeCount}`}}</div>
              </div>
            </div>
						<div class="address flex-col-start-start">
							<div class="city">
								{{`${detailData?.venue.cityName || ''} - ${detailData?.venue.name || ''}`}}
							</div>
							<div class="addr">{{detailData?.venue.address || ''}}</div>
						</div>
						<img src="../../assets/location.png" class="location-img">
					</div>
					<div class="extra order-tip" v-if="detailData">
            <p class="item-wrap " v-if="!detailData?.refundEnabled">
              <i class="icon"></i>{{ t('No refunds') }}
            </p>
            <p class="item-wrap">
                <i class="icon" :class="detailData?.transferEnabled ? 'transfer' : 'notransfer'"></i>{{ detailData?.transferEnabled ? t('Transferable') : t('Not transferable') }}
            </p>
					</div>
				</div>
        <div class="product-detail">
          <div class="flex-row-between-center">
            <div class="product-detail-title">{{t('Detail')}}</div>
            <div class="lang-toggle flwx-row-between-center" @click="showLangModal = true" v-if="currentLang">
              <i class="lang-icon"></i>
              {{getLangLabel(currentLang)}}
              <i class="down-icon"></i>
            </div>
          </div>
          <RichText class="product-detail-ct" :ct="currentDescription"></RichText>
        </div>
      </div>
      <!-- <div class="bottom-btn">
        <div class="buy-btn" @click="buyFn" :class="{'count-time':detailData?.limitedPurchaseStartTime > new Date().getTime(),'disabled':detailData?.limitedPurchaseStartTime > new Date().getTime() || detailData?.limitedPurchaseEndTime < new Date().getTime()}">
            {{ detailData && detailData?.limitedPurchaseEndTime > new Date().getTime() ? t('Purchase') : t('Ended')  }}
          <div class="time" v-if="detailData && detailData?.limitedPurchaseStartTime > new Date().getTime()">{{`${t('Countdown')}：${timeCount}`}}</div>
        </div>
      </div> -->
      <ModalFromBot v-model:is-show="isShowBuyModal">
        <div class="buy-modal">
          <div class="row-title flex-row-start-center">{{t('Showtime')}}</div>
          <div class="ticket-wrapper">
            <div class="session-list flex-row-start-center">
              <template v-for="(item,index) in detailData?.sessions" :key="index">
                <div class="session-list-item flex-col-start-start"  @click="chooseSession(index)" :class="{'active':sessionCur === index}">
                  <div class="name">{{item?.valueName}}</div>
                </div>
              </template>
            </div>
            <div class="row-title flex-row-start-center">{{t('Ticket file')}}</div>
            <div class="product-list flex-col-start-start" v-if="detailData">
              <div class="product-list-item flex-row-between-center"  v-for="(ticketItem,ticketIdx) in detailData?.sessions[sessionCur]?.children" :key="ticketIdx" @click="chooseProduct(ticketIdx)" :class="{'active':productCur === ticketIdx,'disbaled':!ticketItem.stock}">
                <div class="name">{{ticketItem?.valueName}}</div>
                <div class="price" :class="{'disabled':!ticketItem?.stock}">{{symbolByCurrency[ticketItem.priceSymbol]}}<span class="number-font">{{ticketItem?.price || 0}}</span> <span class="thline" v-if="ticketItem?.marketPrice !== ticketItem?.price">{{ticketItem.priceSymbol}}<span>{{ticketItem?.marketPrice || 0}}</span></span> </div>
                <div class="disabled-text">{{ticketItem?.stock ? "" : t('Sold out')}}</div>
              </div>
            </div>
          </div>
          <div class="selector flex-row-between-center">
            <div class="info flex-col-between-start" :style="productData ? 'opacity: 1;' : 'opacity: 0;'">
              <!-- <p class="count">数量<span class="rest">(余 {{productData?.stock}} 张)</span></p> -->
              <p>{{productData?.limitedPurchaseQuantity > 0 ? `${t('Limit tickets per order',{num:productData?.limitedPurchaseQuantity})}`:''}}</p>
            </div>
            <div class="stepper">
              <span class="decrease" @click="handleStep('-')"></span>
              <input class="number" v-model="stepNumber" @input="(e:any)=>{
                if (e.target.value) {
                  stepNumber = e.target.value > productData?.limitedPurchaseQuantity ? productData?.limitedPurchaseQuantity : e.target.value
                }else{
                  stepNumber = 1
                }
                }" />
              <span class="increase" @click="handleStep('+')"></span>
            </div>
          </div>
          <div class="modal-footer">
            <p class="flex-row-start-end" :style="productData ? 'opacity: 1;' : 'opacity: 0;'">{{symbolByCurrency[detailData?.priceSymbol]}}<span class="number-font">{{$BigNumber(stepNumber || 0).times(productData?.price || 0).toFixed(2)}}</span></p>
            <div class="confirm-btn flex-row-center-center" @click="goConfirm">{{t('Confirm')}}</div>
          </div>
        </div>
      </ModalFromBot>
      <ModalFromBot v-model:is-show="showLangModal">
      <div class="language-modal flex-col-center-center">
        <p class="title">{{t('Language Switch')}}</p>
        <div class="lang-list">
          <div
            class="lang-list-item flex-row-between-center"
            v-for="(item, index) in detailData?.descriptionLangList"
            :key="index"
            @click="()=>{
              setDescriptionLang(item)
            }"
            :class="{ active: item.defaultLang === 'true'}"
          >
            <p class="flex-row-start-center">
              <span>{{ getLangLabel(item.lang) }}</span>
            </p>
            <p class="check"></p>
          </div>
        </div>
      </div>
    </ModalFromBot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-detail-layout {
  height: 100%;
  min-height: 100vh;
  background: #071412;
  .product-bg{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      aspect-ratio: 375/375;
      img{
        width: 100%;
        height: 100%;
      }
      .bg-shadow{
				position: absolute;
				width: 100%;
				height: 72px;
				background: linear-gradient(0deg, #071412 0%, rgba(7, 20, 18, 0.00) 100%);
				bottom: 0;
			}
    }
 
  .body {
    padding: 10px 16px;
    color: #fff;
    /* height: calc(100vh - 90px); */
    /* padding-bottom: 90px; */
    overflow-y: scroll;
    padding-top: 200px;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    
    .product-info {
      height: 122px;
      gap: 12px;
      .left {
        .van-image{
          width: 96px;
          height: 122px;
          img {
            object-fit: contain;
          }
        }
      }
      .right {
        height: 100%;
        flex: 1;
        .title {
          font-size: 14px;
          line-height: 1.6;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 将对象作为弹性伸缩盒子模型显示 */
          display: -webkit-box;
          /* 限制在一个块元素显示的文本的行数 */
          /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
          -webkit-line-clamp: 2;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-box-orient: vertical;
          .tag {
            font-size: 8px;
            display: inline-flex;
            padding: 3px 4px;
            justify-content: center;
            align-items: center;
            bottom: 2px;
            gap: 2px;
            border-radius: 4px;
            margin-right: 6px;
            background: linear-gradient(
              224deg,
              #eaadff 0%,
              #efdbff 44.6%,
              #76d6ff 98.01%
            );
          }
        }
        .store-title {
          font-size: 12px;
          line-height: 1;
          .right-icon {
            width: 16px;
            height: 16px;
            background: url(../../assets/right-icon-white.svg);
            background-repeat: no-repeat;
            background-size: contain;
          }
        }
        .store-time {
						color: rgba(255, 255, 255, .6);
						// color: #838383;
						font-family: "D-DIN Exp";
						font-size: 12px;
						font-style: normal;
						font-weight: 400;
						line-height: 16px;
						margin-top: 8px;
						/* 133.333% */
					}
        .store-address {
          font-size: 11px;
          color: #565662;
          overflow: hidden;
          text-overflow: ellipsis;
          /* 将对象作为弹性伸缩盒子模型显示 */
          display: -webkit-box;
          /* 限制在一个块元素显示的文本的行数 */
          /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
          -webkit-line-clamp: 1;
          /* 设置或检索伸缩盒对象的子元素的排列方式 */
          -webkit-box-orient: vertical;
        }
        .price {
          color: #ff3456;
          font-size: 21px;
          .coin {
            font-size: 12px;
            margin-right: 2px;
          }
        }
      }
    }
    .location-bar{
				width: 100%;
				height: 180px;
				border-radius: 12px;
				background: #202a28;
				/* background: #FFF; */
				box-sizing: border-box;
        margin-top: 20px;
				.main{
					position: relative;
					padding: 14px;
					height: 138px;
					border-bottom: 1px solid rgba($color: #fff, $alpha: 0.1);
					box-sizing: border-box;
					.price{
						// color:  #1CF2E4;
						color:  #1CF2E4;
						font-family: "D-DIN Exp";
						font-size: 16px;
						font-style: normal;
						font-weight: 700;
						line-height: 20px; /* 133.333% */
						display: flex;
            flex-direction: column;
						justify-content: flex-start;
						align-items: start;
            .coin{
              font-size: 12px;
            }
						.market-price{
							color: #898989;
							font-family: "PingFang SC";
							font-size: 10px;
							font-style: normal;
							font-weight: 400;
							text-decoration: line-through;
						}
					}
          .buy-btn{
            display: flex;
            width: 155px;
            height: 50px;
            padding: 8px 10px;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #070B14;
            text-align: center;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            border-radius: 100px;
            background: linear-gradient(111deg, #FFF853 4.98%, #6EEF94 56.05%, #2AD8CD 95.37%);
            margin: 0;
            &.disabled{
              pointer-events: none;
              opacity: 0.3;
            }
            &.count-time{
              /* height: 60px; */
              font-size: 14px;
              line-height: 22px;
              /* bottom: 14px; */
              .time{
                font-size: 10px;
                color: #070B14;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: 14px; /* 140% */
              }
            }
          }
          .address{
            margin-top: 18px;
          }
					.city{
						width: 85%;
						color: #fff;
						font-family: Poppins;
						font-size: 12px;
						font-style: normal;
						font-weight: 400;
						line-height: 16px; /* 133.333% */
						text-overflow: ellipsis;
						  overflow: hidden;
						  word-break: break-all;
						  white-space: nowrap;
					}
					.addr{
						width: 280px;
						color: #898989;
						font-family: Poppins;
						font-size: 10px;
						font-style: normal;
						font-weight: 400;
						margin-top: 8px;
						line-height: 14px; /* 140% */
						text-overflow: ellipsis;
						  overflow: hidden;
						  word-break: break-all;
						  white-space: nowrap;
					}
					.location-img{
						width: 98px;
						height: 64px;
						position: absolute;
						right: 0;
						bottom: 0;
					}
					
				}
				.extra {
					color: #898989;
					width: 100%;
					font-size: 12px;
					display: flex;
					justify-content: flex-start;
					align-items: center;
					gap: 16px;
					padding-left: 12px;
					// border-top: 2px solid #eee;
					.item-wrap {
						display: flex;
						justify-content: flex-start;
						align-items: center;
					}
				
					.icon {
						display: inline-block;
						width: 16px;
						height: 16px;
						margin-right: 4px;
						image{
							width: 100%;
							height: 100%;
						}
					}
				}
				
			}
    .order-tip{
      font-size: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap:16px;
      margin-top: 12px;
      .item-wrap{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap:4px;
      }
      .icon{
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url(../../assets/x-circle.svg);
        background-size: contain;
        background-repeat: no-repeat;
        &.transfer{
          background: url(../../assets/transfer.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
        &.notransfer{
          background: url(../../assets/no_transfer.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
    .product-detail {
      padding-top: 16px;
      &-title {
        color: #fff;
        font-size: 16px;
      }
      .lang-toggle{
        display: inline-flex;
        padding: 6px 8px;
        align-items: center;
        gap: 4px;
        border-radius: 6px;
        border: 0.5px solid rgba(110, 250, 151, 0.20);
        background: linear-gradient(90deg, rgba(110, 250, 151, 0.00) 0%, rgba(110, 250, 151, 0.50) 100%);
        .lang-icon{
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url(../../assets/locale.svg);
          background-size: contain;
          background-repeat: no-repeat;
        }
        .down-icon{
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../assets/down-white.svg);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      &-ct {
        padding-top: 16px;
        font-size: 14px;
        line-height: 1.2;
      }
    }
  }
  .bottom-btn{
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 110px;
    left:0
  }
  
}
.buy-modal {
  .row-title{
    padding-left: 16px;
    color: #fff;
    font-size: 12px;
  }
  .ticket-wrapper{
    padding: 0 16px;
    .row-title{
      padding: 0;
    }
  }
  .session-list{
    gap:12px;
    width: 100%;
    /* height: 190px; */
    overflow-y: scroll;
    padding-bottom: 16px;
    margin-top: 8px;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    .row-title{
      padding: 0;
    }
    
    &-item{
      display: inline-flex;
      height: 48px;
      padding: 16px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 8px;
      border: 1px solid #545769;
      font-size: 12px;
      color: #FFF;
      font-weight: 700;
      &.active{
        color: #070B14;
        border-radius: 8px;
        background: linear-gradient(224deg, #EAADFF 0%, #EFDBFF 44.6%, #76D6FF 98.01%);
      }
    }
  }
  .product-list {
    gap:12px;
    width: 100%;
    /* height: 190px; */
    overflow-y: scroll;
    padding-bottom: 16px;
    margin-top: 8px;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    
    &-item {
      width: 100%;
      position: relative;
      border: 1px solid #545769;
      border-radius: 8px;
      height: 50px;
      justify-content: space-between;
      padding: 0 16px;
      gap: 30px;
      cursor: pointer;
      &.disbaled{
        pointer-events: none;
      }
      .name {
        color: #fff;
        z-index: 2;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
      }
      .price {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #fff;
        /* font-size: 12px; */
        font-weight: 700;
        &.disabled{
          color: #9C9CAA;
        }
        .number-font {
          font-size: 16px;
          font-weight: 700;
        }
        .thline{
          font-size: 10px;
          text-decoration: line-through;
          color: #9C9CAA;
          margin-left: 4px;
        }
      }
      .disabled-text{
        width: max-content;
        color:  #9C9CAA;
        font-size: 10px;
        font-weight: 500;
      }
      &.active {
        background: linear-gradient(
            224deg,
            #eaadff 0%,
            #efdbff 44.6%,
            #76d6ff 98.01%
          );
        .name{
          color:#070B14 ;
        }
        .price {
          color: #070B14;
        }
      }
    }
  }
  .selector{
    padding: 12px 16px;
    box-shadow: 0px -5px 12px 0px rgba(255, 255, 255, 0.05);
    .info{
      font-size: 12px;
      color: #999999;
      .count{
        color: #fff;
        .rest{
          color: #9C9CAA;
        }
      }
    }
    .stepper{
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 16px;
      .decrease{
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(../../assets/decrease.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
      .number{
        display: inline-block;
        width: 40px;
        text-align: center;
      }
      .increase{
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(../../assets/increase.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }
  .modal-footer{
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #FF3456;
    border-top: 1px solid #545769;
    line-height: 1;
    .number-font{
      font-size: 21px;
      margin-left: 4px;
      line-height:0.8;
      font-weight: 700
    }
    .confirm-btn{
      @include button;
    }
  }
}


.language-modal{
  gap: 24px;
  padding: 24px 16px;
  .title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }
  .lang-list {
    width: 100%;
    &-item {
      width: 100%;
      height: 52px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      &.active {
        .check {
          display: block;
        }
      }
      .check {
        display: none;
        width: 16px;
        height: 16px;
        background: url(../../assets/check.svg);
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>
